import * as React from 'react';
import { connect } from 'react-redux';
import { REGULAR_DRIVER } from '../../../routes/routes';
import './MaritalStatus.css';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import {  postRegularDriverFlow, setMaritalStatus } from '../../../actions/salesActions';
import { ProgressBar, Button, Dropdown, Image } from 'react-bootstrap';

class MaritalStatus extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            maritalStatusList: [],
            selectedMaritalStatus: '',
            selectedMaritalStatusDropdown: false,
            loggedIn: this.props.auth.uid ? true : false,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleMaritalStatusSelection = this.handleMaritalStatusSelection.bind(this);
        this.handleMaritalStatusDropdownToggle = this.handleMaritalStatusDropdownToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.getMaritalStatus = this.getMaritalStatus.bind(this);
    }

    handleClick() {
        this.props.dispatchSetMaritalStatus(this.state.selectedMaritalStatus)
        this.props.dispatchPostRegularDriver()
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async componentDidMount() {
        await this.getMaritalStatus()
    }

    async getMaritalStatus() {
        await postToController(this.props.dispatch, 'GetMaritalStatusSelection', JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            await this.setState({ maritalStatusList: response });
            return true;
        })
    }

    async handleMaritalStatusSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let maritalItem = this.state.maritalStatusList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedMaritalStatus: maritalItem[0] });
        this.setState({ nextDisabled: maritalItem[0] === undefined });
    }

    async handleMaritalStatusDropdownToggle(e: any) {
        await this.setState({
            selectedMaritalStatusDropdown: !this.state.selectedMaritalStatusDropdown
        });
    }

    async handleBack(e: any) {
        this.props.redirectTo(REGULAR_DRIVER)
    }

    public render() {
        let maritalStatusDrop = [];
        if (this.state.maritalStatusList.length > 0) {
            maritalStatusDrop = this.state.maritalStatusList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 pb-5 logged-in" : "pt-lg-5 pb-5 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={60} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div>
                                    <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">{this.props.sales.name}, what's your marital status</p>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-lg-12 col-md-12 col-12 p-lg-0">
                                        <Dropdown
                                            id="maritalStatus-select-dropdown"
                                            className="fit-full"
                                            onSelect={this.handleMaritalStatusSelection}
                                            onToggle={this.handleMaritalStatusDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                <div className="row dropdown-height">
                                                    <div className="dropdown-basic-title-text col-11">
                                                        {this.state.selectedMaritalStatus.description}
                                                        {!this.state.selectedMaritalStatus &&
                                                            <p>Marital status</p>
                                                        }
                                                    </div>
                                                    <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedMaritalStatusDropdown ? 'visible' : 'invisible'} alt="" />
                                                    <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedMaritalStatusDropdown ? 'invisible' : 'visible'} alt="" />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu id='maritalStatusDropDown'>
                                                {maritalStatusDrop}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                        <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPostRegularDriver: () => dispatch(postRegularDriverFlow()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetMaritalStatus: (regularDriver: any) => dispatch(setMaritalStatus(regularDriver))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MaritalStatus);